export default {
  kerosene: 'Kerosene',
  gas: 'Gas / Diesel Oil',
  naturalGas: 'Natural Gas',
  lpg: 'LPG - Propane',
};
